import styled from 'styled-components';

export const MAX_POPOVER_HEIGHT_PX = 632;

export const StyledMachineKpiPopover = styled.div`
  width: 450px;
  max-height: ${MAX_POPOVER_HEIGHT_PX}px;
  background-color: ${(props): string => props.theme.kcc.colors.WHITE};
  display: flex;
  flex-direction: column;

  .machine-kpi-popover__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${(props): string => props.theme.kcc.spacing.MD} ${(props): string => props.theme.kcc.spacing.MD}
      ${(props): string => props.theme.kcc.spacing.XS};
    flex-shrink: 0;
  }

  .machine-kpi-popover__title {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.HEADING_4}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    margin: 0;
  }

  .machine-kpi-popover__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props): number => props.theme.kcc.size.S300}px;
    height: ${(props): number => props.theme.kcc.size.S300}px;
    color: ${(props): string => props.theme.kcc.colors.TEXT};

    .ant-btn-icon {
      display: flex;
    }
  }

  .machine-kpi-popover__body {
    flex: 1;
    min-height: 0;
    padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.MD}
      ${(props): string => props.theme.kcc.spacing.LG};
    display: flex;
    flex-direction: column;
  }

  .machine-kpi-popover__list-wrapper {
    position: relative;
    max-height: 420px;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex-shrink: 1;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      background: linear-gradient(to bottom, transparent, ${(props): string => props.theme.kcc.colors.WHITE});
      pointer-events: none;
      opacity: 1;
      transition: opacity 0.2s ease;
    }

    &.machine-kpi-popover__list-wrapper--at-bottom::after {
      opacity: 0;
    }
  }

  .machine-kpi-popover__list-scroll {
    flex: 1;
    min-height: 0;
    max-height: 420px;
    overflow-y: auto;
    overflow-anchor: none;
  }

  .machine-kpi-popover__skeleton {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .machine-kpi-popover__skeleton-item {
    display: flex;
    align-items: flex-start;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
    padding: 0;

    &:not(:last-child) {
      border-bottom: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
        ${(props): string => props.theme.kcc.colors.GRAY_100};
      padding-bottom: ${(props): string => props.theme.kcc.spacing.SM};
      margin-bottom: ${(props): string => props.theme.kcc.spacing.SM};
    }
  }

  .machine-kpi-popover__skeleton-thumbnail {
    flex-shrink: 0;

    .ant-skeleton-avatar {
      border-radius: 0;
    }
  }

  .machine-kpi-popover__skeleton-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};

    .ant-skeleton-input {
      height: 16px !important;
      min-width: 0 !important;
    }
  }

  .machine-kpi-popover__skeleton-name {
    .ant-skeleton-input {
      width: 60% !important;
      height: 18px !important;
    }
  }

  .machine-kpi-popover__skeleton-arrow {
    flex-shrink: 0;
    align-self: center;
  }

  .machine-kpi-popover__hint-skeleton {
    flex-shrink: 0;
    margin-top: ${(props): string => props.theme.kcc.spacing.BASE};

    .ant-skeleton-paragraph {
      margin-bottom: 0;
    }

    .ant-skeleton-paragraph > li {
      height: 18px;
    }

    .ant-skeleton-paragraph > li + li {
      margin-block-start: 12px;
    }
  }

  .machine-kpi-popover__loader {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    padding: ${(props): string => props.theme.kcc.spacing.XS} 0;
  }

  .machine-kpi-popover__item {
    display: flex;
    align-items: flex-start;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
    padding-right: ${(props): string => props.theme.kcc.spacing.XS};

    &:not(:last-child) {
      border-bottom: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
        ${(props): string => props.theme.kcc.colors.GRAY_100};
      padding-bottom: ${(props): string => props.theme.kcc.spacing.SM};
      margin-bottom: ${(props): string => props.theme.kcc.spacing.SM};
    }
  }

  .machine-kpi-popover__item-thumbnail {
    flex-shrink: 0;
    width: ${(props): number => props.theme.kcc.size.S500}px;
    height: ${(props): number => props.theme.kcc.size.S500}px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props): string => props.theme.kcc.colors.GRAY_50};
    overflow: hidden;

    .ant-image {
      width: 100%;
      height: 100%;
      display: block;
    }

    img {
      width: ${(props): number => props.theme.kcc.size.S500}px;
      height: ${(props): number => props.theme.kcc.size.S500}px;
      object-fit: cover;
    }

    .svg-icon {
      width: ${(props): number => props.theme.kcc.size.S400}px;
      height: ${(props): number => props.theme.kcc.size.S400}px;
      color: ${(props): string => props.theme.kcc.colors.GRAY_400};
    }
  }

  .machine-kpi-popover__item-content {
    flex: 1;
    min-width: 0;
  }

  .machine-kpi-popover__item-name {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin: 0 0 ${(props): string => props.theme.kcc.spacing.XXS};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
  }

  .machine-kpi-popover__item-row {
    display: flex;
    justify-content: space-between;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.BASE};
    color: ${(props): string => props.theme.kcc.colors.TEXT};

    &:not(:last-child) {
      margin-bottom: ${(props): string => props.theme.kcc.spacing.XXS};
    }
  }

  .machine-kpi-popover__item-label {
    flex: 1;
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
    word-break: break-word;
  }

  .machine-kpi-popover__item-value {
    flex: 1;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    text-align: right;
    word-break: break-word;
  }

  .machine-kpi-popover__item-arrow {
    flex-shrink: 0;
    align-self: center;

    &.ant-btn {
      width: ${(props): number => props.theme.kcc.size.S400}px;
      height: ${(props): number => props.theme.kcc.size.S400}px;
      border-radius: 50%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ant-btn-icon {
      display: flex;
    }
  }

  .machine-kpi-popover__hint {
    flex-shrink: 0;
    margin-top: ${(props): string => props.theme.kcc.spacing.BASE};
    display: flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.LG};
    background-color: ${(props): string => props.theme.kcc.colors.PETROL[100]};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 calc(50% + 8px), 8px 50%, 0 calc(50% - 8px));

    .svg-icon {
      flex-shrink: 0;
      width: ${(props): number => props.theme.kcc.size.S300}px;
      height: ${(props): number => props.theme.kcc.size.S300}px;
      color: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }

  .machine-kpi-popover__hint-text {
    flex: 1;
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.BASE};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    margin: 0;
  }

  .machine-kpi-popover__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: ${(props): string => props.theme.kcc.spacing.XS} ${(props): string => props.theme.kcc.spacing.MD};
    border-top: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
      ${(props): string => props.theme.kcc.colors.GRAY_100};
    flex-shrink: 0;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};

    .ant-btn:first-child {
      width: 118px;
    }

    .ant-btn:last-child {
      width: 100px;
    }
  }
`;
